export const localeCompareSorter = (extractor) => (a, b) => (extractor(a) || '').localeCompare((extractor(b) || ''));

export const numberCompareSorter = (extractor) => (a, b) => (extractor(a) || 0) - (extractor(b) || 0);
